<template>
  <RevDrawer
    :close-button-label="i18n(translations.close)"
    :name="MODAL_NAMES.INSTRUCTIONS"
    :title="i18n(translations.title)"
  >
    <template #body>
      <div>
        <h2 class="heading-2">
          {{ i18n(translations.productTitle, { title: productTitle }) }}
        </h2>
        <RevDocument
          class="mt-32"
          :name="instructions as string"
          :url="instructions as string"
        />
      </div>
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDocument } from '@ds/components/Document'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from './InstructionsModal.translations'

defineProps<{
  productTitle: GetProductResponse['titles']['raw']
  instructions: GetProductResponse['instructions']
}>()
const i18n = useI18n()
</script>
